import { UMStack, UMR } from '../_components';
import { ToneToolGroup } from './ToneToolGroup';
import type { useNetwork } from './useNetwork';

export function PlantControls({ network: n, blocked }: {
  network: ReturnType<typeof useNetwork>; blocked: boolean;
}) {
  const disabled = blocked || n.loading || !!n.activeTool;
  return <UMStack gap={12}>
    <ToneToolGroup label="Centrales de production" activeId={n.activeTool}
      tools={[
        { id: 'plant', icon: 'add_location_alt', label: 'Placer', tone: 'primary' as const, disabled: disabled && n.activeTool !== 'plant' },
        { id: 'remove-plant', icon: 'location_off', label: 'Supprimer', tone: 'danger' as const,
          disabled: !n.network.plants.length || (disabled && n.activeTool !== 'remove-plant') },
      ]}
      onSelect={(id) => { if (id === 'plant' || id === 'remove-plant') n.start(id); }} />
    <div style={{ fontSize: 12, color: UMR.textMuted }}>
      {n.network.plants.length ? `${n.network.plants.length} centrale(s)` : 'Aucune centrale placée.'}
      {n.network.plants.length > 0 && <div>Glissez-déposez une centrale sur la carte pour la déplacer, puis validez ou annulez.</div>}
    </div>
  </UMStack>;
}
